import React, { useReducer, useEffect } from 'react';
import ReactTable from 'react-table';
import CircularProgress from '@material-ui/core/CircularProgress';
import API from 'helpers/API';
import {
  SET_TABLE_DATA,
  SET_TABLE_FAILED_MESSAGE,
  SET_TABLE_LOADING,
  statsByFilterTableReducer,
} from './Reducers';
import { style, headerStyle } from './StatsByFilterTableStyles';
import styles from './styles.scss';

const StatsByFilterTable = (props) => {
  const {
    sinkConfigurationId,
    filter,
    dates,
    carrierReferences,
    promisedDates,
    filterName,
    carrierData,
    addDataForExport,
  } = props;

  const [state, dispatch] = useReducer(statsByFilterTableReducer, { data: null, failedMessage: '', loading: false });

  const getCarrierName = (reference) => {
    const carrier = reference && reference.length > 0
      ? carrierData.find(c => c.key === reference) : {};
    return carrier && carrier.name && carrier.name.length > 0 ? carrier.name : '[Unknown]';
  };

  const friendlyDate = (date) => `${date.substring(6)}/${date.substring(4, 6)}/${date.substring(0, 4)}`;

  useEffect(() => {
    function prepareDataForExport(statsRows) {
      return statsRows.map(row => {
        const name = row.is_shipment_event_filter_row ? filterName : getCarrierName(row.reference);
        const friendlyStatsByDate = Object.fromEntries(
          Object.entries(row.stats_by_date).map(([date, value]) => [friendlyDate(date), value]),
        );
        return {
          Filter_CarrierName: name,
          ...friendlyStatsByDate,
        };
      });
    }

    async function fetchData() {
      dispatch({ type: SET_TABLE_LOADING });
      try {
        const dataResponse = await API.getNotificationStatistics(sinkConfigurationId, filter, dates, carrierReferences, promisedDates);
        dispatch({ type: SET_TABLE_DATA, data: dataResponse });
        addDataForExport(prepareDataForExport(dataResponse.stats_rows));
      } catch (error) {
        dispatch({ type: SET_TABLE_FAILED_MESSAGE, failedMessage: `Failed to fetch statistics for ${filterName}. Please try again later.` });
      }
    }

    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sinkConfigurationId, filter, dates, carrierReferences, promisedDates, filterName, addDataForExport]);

  const renderStatusCarrierColumnCell = (row) => {
    if (row.original.is_shipment_event_filter_row) {
      return <span style={{ fontWeight: 'bold' }}>{filterName}</span>;
    }
    return getCarrierName(row.original.reference);
  };

  const dataColumns = [
    {
      Header: 'Filter/Carrier Name', style, headerStyle, minWidth: 150, Cell: row => renderStatusCarrierColumnCell(row),
    },
    ...dates.map(date => ({
      Header: friendlyDate(date), style, headerStyle, Cell: row => row.original.stats_by_date[date],
    })),
  ];

  if (state.loading) {
    return (
      <div className={styles.statsByFilterMessage}>
        Loading data for {filterName} <CircularProgress thickness={4} color="inherit" size={20} variant="indeterminate" />
      </div>
    );
  }

  if (state.failedMessage.length > 0) {
    return (
      <div className={styles.statsByFilterError}>
        {state.failedMessage}
      </div>
    );
  }

  return (state.data
    && (
    <ReactTable
      data={state.data.stats_rows}
      columns={dataColumns}
      sortable={false}
      showPaginationBottom={false}
      resizable={false}
      totalRows={state.data.stats_rows.length}
      minRows={0}
    />
    )
  );
};

export default StatsByFilterTable;
